import Vue from 'vue';
import {
  cloneDeep, difference, find, forEach,
} from 'lodash';
import SharedMixinMethods from './shared_mixin_methods';

// const cardFlip = require('./../sounds/topic-card-flip.wav');

// if a method is missing, please look at either helper_methods.js OR shared_mixin_methods.js first
export default {
  mixins: [SharedMixinMethods],
  data() {
    return {
      originalProperties: {},
    };
  },
  created() {
    // Tried moving this to a shared mixing but it exploded
    this.originalProperties = Object.freeze(cloneDeep(this.element.properties));
    this.$eventHub.$on(this.element.uuid, this.onEventChange);
  },
  beforeDestroy() {
    this.$eventHub.$off(this.element.uuid);
  },
  methods: {
    onEventChange(event) {
      // for some reason it can't find properties lol, so the ol' classic if statement we go.
      if (this.properties) {
        this.fireEventRecorder(event);
        if (event.type === 'show') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          if (target) target.properties.hidden = false;
        } else if (event.type === 'hide') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          if (target) target.properties.hidden = true;
        } else if (event.type === 'reset_to_default') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          this.resetToDefault(target);
        } else if (event.type === 'show_with_survey') {
          this.showWithSurvey(event);
        } else if (event.type === 'show_survey') {
          this.showSurvey(event);
        } else if (event.type === 'show_modal') {
          this.showModal(event);
        } else if (event.type === 'hide_modal') {
          this.hideModal(event);
        } else if (event.type === 'hide_keyboard') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          this.hideKeyboard(target);
        } else if (event.type === 'open_keyboard') {
          this.openKeyboard(event);
        } else if (event.type === 'pause_audio') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          target.$el.pause();
        } else if (event.type === 'play_audio') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          target.$el.play();
        } else if (event.type === 'play_video') {
          this.playVideo(event.target_uuid);
        } else if (event.type === 'restart_video') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          target.$el.pause();
          target.$el.currentTime = 0;
          target.$el.play();
        } else if (event.type === 'pause_video') {
          // const target = this.searchInRootForElementOrComponent(event.target_uuid);
          // target.$el.pause();
          this.pauseVideo(event.target_uuid);
        } else if (event.type === 'timer_start') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          this.timerStart(target);
        } else if (event.type === 'timer_stop') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          this.timerStop(target);
        } else if (event.type === 'timer_reset') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          this.timerReset(target);
        } else if (event.type === 'flip') {
          if (event.target_uuid) {
            const targetObject = this.searchInRootForElementOrComponent(event.target_uuid);
            if (targetObject) this.flip(targetObject);
          } else if (event.front_uuid) {
            const targetObject = this.searchInRootForElementOrComponent(event.front_uuid);
            if (targetObject) this.setFlipFront(targetObject);
          } else if (event.back_uuid) {
            const targetObject = this.searchInRootForElementOrComponent(event.back_uuid);
            if (targetObject) this.setFlipBack(targetObject);
          }
          const isTarget = find(event.perspective_boxes, o => o === this.element.uuid);
          if (isTarget) this.setFlipPerspective();
        } else if (event.type === 'reverse_flip') {
          this.clearFlip();
        } else if (event.type === 'reset_tree_to_default') {
          const parentTarget = this.searchInRootForElementOrComponent(event.target_uuid);
          // // reset cards that are flipped over
          // const flipCards = document.getElementsByClassName('card-flip');
          // console.log("flipCards:", flipCards);
          // // loop through all the cards and remove any that have an active class
          // forEach(flipCards, (card) => {
          //   card.classList.remove('active');
          // });
          // // reset any active blur-this containers.
          // const blurThis = document.getElementsByClassName('blur-this');
          // // loop through all the container and remove any that have an active class
          // forEach(blurThis, (container) => {
          //   container.classList.remove('active');
          // });
          this.resetTreeToDefault(parentTarget);
        } else if (event.type === 'reset_app') {
          this.resetTreeToDefault(this.$root);
        } else if (event.type === 'add_class') {
          this.$el.classList.add(event.new_value);
        } else if (event.type === 'remove_class') {
          this.$el.classList.remove(event.new_value);
        } else if (event.type === 'clear_custom_class') {
          const diffClasses = difference(this.$el.classList, this.originalClasses);
          for (let i = 0; i < diffClasses.length; i += 1) {
            this.$el.classList.remove(diffClasses[i]);
          }
        } else if (event.type === 'get_form_data') {
          const target = this.searchInRootForElementOrComponent(event.target_uuid);
          // because there's no validation on page editor lol.
          if (target) {
            this.getFormData(event, target);
          }
        } else if (event.type === 'clear_session') {
          // redirect it so we can get a new session for it to register
          this.$eventHub.$emit('event_recorder', event);
        }
      }
    },
    hideKeyboard(target) {
      // Hide target keyboard
      if (target) {
        target.closeKeyboard();
      }
    },
    playVideo(targetUuid) {
      const target = this.searchInRootForElementOrComponent(targetUuid);
      if (target) {
        const lock = Vue.prototype.$videoLock;
        let canPlay = true;
        if (lock && this.properties.silent_video === false && lock.uuid !== this.uuid) {
          canPlay = false;
        }
        if (canPlay) {
          if (this.properties.silent_video === false && !target.$el.autoplay) {
            this.$eventHub.$emit('register_video_lock', { uuid: targetUuid, sessionUuid: this.sessionUuid, name: this.name });
          }
          this.unmuteVideo(targetUuid);
          target.$el.play();
        } else {
          this.videoCallback();
        }
      }
    },
    /**
     * Validates and tries to get form data
     * @param event
     * @param target
     */
    getFormData(event, target) {
      const stillRequired = []; // still required form inputs

      // loop requiredFields and set
      if (target.pageComponent.formData.requiredFields && target.pageComponent.formData.requiredFields.length > 0) {
        let count = 0;
        // Loop through all required form fields
        forEach(target.pageComponent.formData.requiredFields, (val) => {
          const input = document.getElementById(val.id);
          if (input && input.parentNode) {
            // Get the ref so we can call it's methods
            const i = this.searchInRootForElementOrComponent(input.parentNode.id);

            if (val.validation === 'none') {
              // no validation
              count += 1;
            } else if (val.validation === 'filled_in') {
              if (val.value) {
                // If there is a value, increment
                count += 1;
              } else {
                // Otherwise push element to still required array
                stillRequired.push(val);
              }
            } else if (val.validation === 'email') {
              // Call method from element component
              const valid = i.isEmailValid(val.value);
              if (valid) {
                count += 1;
              } else {
                i.updateErrorMsg(val.validation);
                stillRequired.push(val);
              }
            } else {
              stillRequired.push(val);
            }
          }
        });

        // Check if all required fields are filled in
        if (count === target.pageComponent.formData.requiredFields.length) {
          if (target && target.pageComponent) {
            if (target.pageComponent.formData) {
              // Save form data
              const newEvent = {};
              newEvent.target_uuid = target.pageComponent.uuid;
              newEvent.type = 'save_form'; // use this on button click and test with register action, maybe even add in this method
              newEvent.data = target.pageComponent.formData;
              newEvent.sessionUuid = target.sessionUuid;
              this.$eventHub.$emit(target.pageComponent.uuid, newEvent);

              // Hide form parent and button
              if (event.form_container) {
                const hideEvent = {};
                hideEvent.target_uuid = event.form_container;
                hideEvent.type = 'hide_modal';
                this.$eventHub.$emit(target.pageComponent.uuid, hideEvent);
              }

              // Show success modal (or target modal)
              if (event.modal_target) {
                const showSuccess = {};
                showSuccess.target_uuid = event.modal_target;
                showSuccess.type = 'show_modal';
                this.$eventHub.$emit(target.pageComponent.uuid, showSuccess);
              }

              // Trigger form reset
              // eslint-disable-next-line no-param-reassign
              target.stillRequiredFields = 'reset_form'; // trigger watcher to check resetForm on form-root
            }
          }
        } else {
          // Set stillRequired fields
          // eslint-disable-next-line no-param-reassign
          target.stillRequiredFields = stillRequired; // trigger watcher populate error message on each form input
        }
      }
    },
    /**
     * Set the back side of the flipping object
     * @param target
     */
    setFlipBack(target) {
      const flipClasses = ['side', 'back'];
      for (let i = 0; i < flipClasses.length; i += 1) {
        target.$el.classList.add(flipClasses[i]);
      }
    },
    /**
     * Set the front part of the flipping object
     * @param target
     */
    setFlipFront(target) {
      const flipClasses = ['side', 'front'];
      for (let i = 0; i < flipClasses.length; i += 1) {
        target.$el.classList.add(flipClasses[i]);
      }
    },
    setFlipPerspective() {
      const flipClasses = ['card-flip-container', 'animation-flip-container'];
      for (let i = 0; i < flipClasses.length; i += 1) {
        this.$el.classList.add(flipClasses[i]);
      }
    },
    /**
     * The inverse of front flip
     */
    clearFlip() {
      this.$el.classList.remove('card-flip');

      const parentEle = this.$el.parentElement;
      if (parentEle) {
        parentEle.classList.remove('card-perspective');
      }
    },
    /**
     * This triggers the active state on the front card for flip to happen
     */
    flip(target) {
      // const audio = new Audio(cardFlip);
      // if (audio) audio.play();
      // get the target
      target.$el.classList.add('card-flip');

      const parentEle = target.$el.parentElement;
      if (parentEle) parentEle.classList.add('card-perspective');

      setTimeout(() => {
        target.$el.classList.toggle('active');
      }, 50);
    },
    timerStart(target) {
      if (target && target.startTimer) target.startTimer();
    },
    timerStop(target) {
      if (target && target.stopTimer) target.stopTimer();
    },
    timerReset(target) {
      if (target && target.restartTimer) target.restartTimer();
    },
    showSurvey(event) {
      const target = this.searchInRootForElementOrComponent(event.target_uuid);
      const skippableTarget = event.show_on_survey_close;
      // eslint-disable-next-line no-param-reassign
      if (target) {
        target.properties.hidden = false;
        // Remove global skippable target
        if (skippableTarget) {
          target.skipTarget = skippableTarget; // Skip target none
        } else {
          target.skipTarget = null; // Skip target none
        }
        target.exitSurvey = true; // Set survey to an exit survey
      }
    },
    showWithSurvey(event) {
      // const target = this.searchInRootForElementOrComponent(event.target_uuid);
      let survey = this.searchInRootForElementOrComponent(event.survey);
      if (!survey) {
        survey = this.searchInRootForElementOrComponent(event.source);
      }
      this.log('showWithSurvey', event);
      // Show original target lsourceike normal
      if (survey) {
        if (survey.cardClicked === true) {
          // this.properties.hidden = false;
          // *********************
          // We should hide parent wells at this point and any open wells
          // ALSO push elements that need to be hidden again to an array for RESET (reset back to hidden)
          // this is straight dumb but im on a time crunch
          const hideEvent = {};
          hideEvent.target_uuid = event.target_uuid;
          hideEvent.type = 'show';
          this.$eventHub.$emit(this.element.uuid, hideEvent);
        } else {
          // check if any of the cards have been clicked, show survey
          // Open the targeted survey
          this.log('test');
          survey.properties.hidden = false;

          // Set up skippable target
          survey.skipTarget = event.target_uuid; // Skip target
          survey.cardClicked = true;
        }
      }
    },
    openKeyboard(event) {
      // get uuid of the right keyboard, show it and connect it
      const keyboard = document.getElementById(event.keyboard);

      if (keyboard && this.$refs[`draggableRoot-${this.pageComponent.uuid}`]) {
        // show keyboard and hook it up
        this.$refs[`draggableRoot-${this.pageComponent.uuid}`].style.display = 'block';
        keyboard.style.display = 'block';
        const target = document.getElementById(event.target);
        this.input = target;
      }
    },
  },
};
